import { render, staticRenderFns } from "./workOrder-list.vue?vue&type=template&id=2b538d26&scoped=true&"
import script from "./workOrder-list.vue?vue&type=script&lang=js&"
export * from "./workOrder-list.vue?vue&type=script&lang=js&"
import style0 from "./workOrder-list.vue?vue&type=style&index=0&id=2b538d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b538d26",
  null
  
)

export default component.exports